module.exports = __webpack_public_path__ + "img/rigid-material.707b83e.svg";